import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource-variable/inter";
import "@fontsource/bebas-neue/400.css";
import Router from "./router";
import { initNavigation } from "./lib/navigation";
import { Buffer } from "buffer";

// Ensure Buffer is available globally for browser libraries expecting the Node.js API
// such as music-metadata-browser.
(globalThis as any).Buffer = Buffer;

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
);

initNavigation();
